import { useState, useEffect } from 'react'
import { useGameStore } from '@/store/gameStore'
import { SEASONAL_EVENTS, SeasonalEvent } from '@/config/seasonalConfig'
import { Sparkles } from 'lucide-react'

export function SeasonalDisplay() {
  const [currentEvent, setCurrentEvent] = useState<SeasonalEvent | null>(null)
  const [daysRemaining, setDaysRemaining] = useState(0)
  
  const { day } = useGameStore()
  
  // Check for active seasonal events based on game day
  useEffect(() => {
    const totalDaysInYear = 365
    const currentDayOfYear = day % totalDaysInYear
    
    for (const event of SEASONAL_EVENTS) {
      const eventStartDay = (event.startMonth - 1) * 30
      const eventEndDay = eventStartDay + event.duration
      
      if (currentDayOfYear >= eventStartDay && currentDayOfYear < eventEndDay) {
        setCurrentEvent(event)
        setDaysRemaining(eventEndDay - currentDayOfYear)
        return
      }
    }
    
    setCurrentEvent(null)
    setDaysRemaining(0)
  }, [day])
  
  if (!currentEvent) return null

  return (
    <span className="hud-chip" style={{ background: 'var(--gold-fill)' }}>
      <Sparkles size={14} style={{ color: 'var(--gold)' }} />
      <span style={{ color: 'var(--text-strong)', fontWeight: 600 }}>{currentEvent.name}</span>
      <span style={{ color: 'var(--text-secondary)' }}>{daysRemaining}d</span>
    </span>
  )
}
